<script setup lang="ts">
import { useEcho } from '@laravel/echo-vue'
import GameScreen from '~/components/scoreapp/GameScreen.vue'
import { type DartsThrow, getGameStore } from '~/stores/localGameStore'

const route = useRoute('live-id')

const { data: game } = await useApi('/games/{game}', {
  path: { game: parseInt(route.params.id as string) },
  key: `game-${route.params.id}`,
  deep: true,
})

if (!game.value) {
  throw new Error('Game not found')
}

const gameState = getGameStore(route.params.id as string)
gameState.initFromApi(game.value)
gameState.settings.showAverages = true

const lastThrow = ref<DartsThrow | null>(null)
const message = ref<{ message: string, home: boolean } | null>(null)

watch(lastThrow, (newValue) => {
  if (newValue) {
    setTimeout(() => {
      message.value = null
    }, 3000)

    if (newValue.ft) {
      message.value = {
        message: 'Game shot!',
        home: gameState.lastThrowIsHomeTeam,
      }
    }
    else {
      message.value = {
        message: newValue.s.toString(),
        home: gameState.lastThrowIsHomeTeam,
      }
    }
  }
})

if (!game.value?.concluded_at) {
  useEcho<Game>(`game.${game.value?.id}`, 'GameThrowEvent', (gameData) => {
    gameState.initFromApi(gameData, true)
    lastThrow.value = gameState.lastThrow ?? null
  })
}
</script>

<template>
  <UiPage>
    <div
      v-if="game"
      :class="{ '!p-0 flex h-full overflow-hidden flex-grow flex-col': gameState.isInitialized && !gameState.getWinnerSimplePlayer, '!overflow-auto h-full': gameState.getWinnerSimplePlayer }"
    >
      <GameScreen
        v-if="game.throws.length > 0"
        :game-id="game.id.toString()"
        :custom-header="null"
        :can-leave="false"
        :view-only="true"
        :event-name="game.label"
        :message="message"
      />
      <GamesGameStatsOverview
        v-else
        :name="game.player1?.name + ' - ' + game.player2?.name"
        :event-name="game.label"
        :starting-score="gameState.getStartingScore"
        :legs-to-play="gameState.getLegsToPlay"
        :best-of="gameState.getBestOf"
        :winner="gameState.getWinnerSimplePlayer ? gameState.getPlayerNameFor(gameState.getWinnerSimplePlayer) : null"
        :bull-winner="gameState.getBullWinner"
        :player1="game.player1?.name ?? ''"
        :player2="game.player2?.name ?? ''"
        :player1-legs="game.player1?.score ?? 0"
        :player2-legs="game.player2?.score ?? 0"
        :player1-average="0"
        :player2-average="0"
        :player1-first9-average="0"
        :player2-first9-average="0"
        :player1-one-eighties="game.player1?.one_eighties ?? 0"
        :player2-one-eighties="game.player2?.one_eighties ?? 0"
        :player1-one-fourty="undefined"
        :player2-one-fourty="undefined"
        :player1-high-checkouts="game.player1?.high_checkouts ?? ''"
        :player2-high-checkouts="game.player2?.high_checkouts ?? ''"
        :player1-leg-darts-used="[]"
        :player2-leg-darts-used="[]"
      />
    </div>
  </UiPage>
</template>
